<template>
    <div class="columns family-home">
        <div class="column is-3">
            <div class="box">
                <div class="profile-pic">
                    <img :src="profilePicture" alt="" />
                    <div class="logout" @click="logout">
                        <b-tooltip label="Iesi din cont"
                            ><b-icon class="has-text-grey" icon="logout"> </b-icon
                        ></b-tooltip>
                    </div>
                </div>
                <div class="divider is-success">INFO</div>
                <div class="account-details has-text-left">
                    <div class="name is-flex is-align-items-center">
                        <div class="icon">
                            <b-icon icon="account"> </b-icon>
                        </div>
                        <div class="text">
                            {{ startCase(familyData.name) }}
                        </div>
                    </div>
                    <div class="name is-flex is-align-items-center">
                        <div class="icon">
                            <b-icon icon="credit-card"> </b-icon>
                        </div>
                        <div class="text">
                            {{ familyData.iban }}
                        </div>
                    </div>
                    <div class="name is-flex is-align-items-center">
                        <div class="icon">
                            <b-icon icon="phone"> </b-icon>
                        </div>
                        <div class="text">
                            {{ familyData.phone }}
                        </div>
                    </div>
                    <div class="name is-flex is-align-items-center">
                        <div class="icon">
                            <b-icon icon="at"> </b-icon>
                        </div>
                        <div class="text">
                            {{ familyData.email }}
                        </div>
                    </div>
                </div>
                <div class="divider is-success">Formulare</div>
                <div class="formulare">
                    <b-menu :activable="false">
                        <b-menu-list>
                            <b-menu-item
                                :active="isActive('/family/home/formular-manual')"
                                tag="router-link"
                                to="/family/home/formular-manual"
                                label="Adauga formular hartie"
                            ></b-menu-item>
                            <b-menu-item
                                :active="isActive('/family/home/formular/online/2025')"
                                tag="router-link"
                                to="/family/home/formular/online/2025"
                            >
                                <template #label>Formulare 2025 <strong>(online)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                :active="isActive('/family/home/formular/hartie/2025')"
                                tag="router-link"
                                to="/family/home/formular/hartie/2025"
                            >
                                <template #label>Formulare 2025 <strong>(hartie)</strong></template></b-menu-item
                            >

                            <b-menu-item
                                :active="isActive('/family/home/formular/online/2024')"
                                tag="router-link"
                                to="/family/home/formular/online/2024"
                            >
                                <template #label>Formulare 2024 <strong>(online)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                :active="isActive('/family/home/formular/hartie/2024')"
                                tag="router-link"
                                to="/family/home/formular/hartie/2024"
                            >
                                <template #label>Formulare 2024 <strong>(hartie)</strong></template></b-menu-item
                            >

                            <b-menu-item
                                :active="isActive('/family/home/formular/online/2023')"
                                tag="router-link"
                                to="/family/home/formular/online/2023"
                            >
                                <template #label>Formulare 2023 <strong>(online)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                :active="isActive('/family/home/formular/hartie/2023')"
                                tag="router-link"
                                to="/family/home/formular/hartie/2023"
                            >
                                <template #label>Formulare 2023 <strong>(hartie)</strong></template></b-menu-item
                            >

                            <b-menu-item
                                :active="isActive('/family/home/formular/online/2022')"
                                tag="router-link"
                                to="/family/home/formular/online/2022"
                            >
                                <template #label>Formulare 2022 <strong>(online)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                :active="isActive('/family/home/formular/hartie/2022')"
                                tag="router-link"
                                to="/family/home/formular/hartie/2022"
                            >
                                <template #label>Formulare 2022 <strong>(hartie)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                v-if="false"
                                :active="isActive('/family/home/formular/online/2021')"
                                tag="router-link"
                                to="/family/home/formular/online/2021"
                            >
                                <template #label>Formulare 2021 <strong>(online)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                v-if="false"
                                :active="isActive('/family/home/formular/hartie/2021')"
                                tag="router-link"
                                to="/family/home/formular/hartie/2021"
                            >
                                <template #label>Formulare 2021 <strong>(hartie)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                v-if="false"
                                :active="isActive('/family/home/formular/online/2020')"
                                tag="router-link"
                                to="/family/home/formular/online/2020"
                            >
                                <template #label>Formulare 2020 <strong>(online)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                v-if="false"
                                :active="isActive('/family/home/formular/hartie/2020')"
                                tag="router-link"
                                to="/family/home/formular/hartie/2020"
                            >
                                <template #label>Formulare 2020 <strong>(hartie)</strong></template></b-menu-item
                            >
                            <b-menu-item
                                v-if="false"
                                :active="isActive('/family/home/formular/2019')"
                                tag="router-link"
                                to="/family/home/formular/2019"
                            >
                                <template #label>Formulare 2019 <strong>(2 ani)</strong></template></b-menu-item
                            >
                        </b-menu-list>
                    </b-menu>
                </div>
            </div>
        </div>
        <div class="column is-9">
            <div class="box">
                <router-view></router-view>
            </div>
        </div>
        <b-modal
            full-screen
            v-model="passwordResetModal"
            has-modal-card
            trap-focus
            :destroy-on-hide="true"
            aria-role="dialog"
            aria-modal
        >
            <template>
                <password-reset @close="closeModal" @changed="onPasswordChanged"></password-reset>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { getUserId } from '@/utils/auth';
import * as toast from '@/utils/toast';
import { mapGetters } from 'vuex';
import startCase from 'lodash/startCase';
const PasswordReset = () => import('./components/PasswordReset');
import defaultAccountPicture from '@/assets/default-account-picture.png';
export default {
    data: () => ({ passwordResetModal: false, defaultAccountPicture }),
    components: { PasswordReset },
    computed: {
        ...mapGetters({
            familyData: 'family/familyData',
            passwordReset: 'family/passwordReset',
        }),
        profilePicture() {
            return this.familyData.name !== ''
                ? `https://eu.ui-avatars.com/api/?rounded=true&color=fff&background=95b65d&size=100&name=${this.familyData.name}`
                : this.defaultAccountPicture;
        },
    },
    methods: {
        startCase,
        getInitials() {
            return;
        },
        isActive(link) {
            return this.$route.path === link;
        },
        closeModal() {
            this.passwordResetModal = false;
            this.logout();
        },
        onPasswordChanged() {
            this.$store.commit('family/SET_PASSWORD_RESET', 1);
        },
        logout() {
            this.$store.dispatch('family/Logout');
            this.$router.push({ path: '/family/login' });
        },
    },
    watch: {
        passwordReset(val) {
            if (val == 0) {
                this.passwordResetModal = true;
            } else {
                this.passwordResetModal = false;
            }
        },
    },
    async created() {
        try {
            const accountId = getUserId('family');
            if (accountId == null || accountId == false) {
                return await this.$store.dispatch('family/Logout'), this.$router.push({ path: '/family/login' });
            }
            this.$store.commit('family/SET_ACCOUNT_ID', +accountId);
            await this.$store.dispatch('family/GetFamilyAccount', accountId);
        } catch (err) {
            console.log('eeerr', err);
        }
    },
};
</script>

<style lang="scss" scoped>
.account-details {
    margin-top: 20px;
    color: #525252;
    line-height: 2;
    font-size: 0.95rem;
    .icon {
        color: #95b65db3;
        font-size: 1.3rem;
    }

    .text {
        margin-left: 10px;
    }
}

::v-deep .menu-list {
    a {
        &:hover {
            background-color: #95b65d !important;
        }

        &.is-active {
            background-color: #95b65d !important;
        }
    }
}

.formulare {
    font-size: 0.95rem;
}

.profile-pic {
    position: relative;

    .logout {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        color: #525252;
    }
}
</style>
